import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import $ from "jquery";
import {
  Paper,
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
} from "@material-ui/core";
import React, { Component } from "react";
import { formateDate, getQueryVariable } from "../utils/utilTools";
import Pagination from "@material-ui/lab/Pagination";
import { VideoLibrary, Flag, FindInPage } from "@material-ui/icons";

require("../assets/css/style.css");
require("../assets/css/news-style.css");
const imageAccount = require("../assets/images/top-ico1.png");
const searchTitle = require("../assets/images/gw.png");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

class SearchOffer extends Component {
  constructor(props) {
    super();
    this.state = {
      selectedDate: new Date(),
    };
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  };

  componentDidMount() {}

  componentDidCatch(error, errorInfo) {
    // console.log("==============", error, errorInfo);
  }

  handleJump() {}

  render() {
    const _state = this.state;
    const { handlePaging, pages, results, classes } = this.props;

    return (
      <div style={{ backgroundColor: "rgb(251 251 251)" }}>
        <Grid
          style={{
            margin: "10px 10px 0 10px",
            width: "100%",
            paddingRight: "10px",
          }}
          container
          spacing={5}
        >
          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-1"
                onClick={() =>
                  window.open(
                    "http://218.90.225.176:8086/yjspt/yjs/home-page.html"
                  )
                }
              >
                <p className="block-word">一件事服务</p>
              </div>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-2"
                onClick={() =>
                  window.open(
                    "http://bdc.taizhou.gov.cn:8011/estateplat-register/page/v2.1/login"
                  )
                }
              >
                <p className="block-word">不动产登记</p>
                {/* <img className="block-word-class" src={require("../assets/images/价格监管.png")} /> */}
              </div>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-3"
                onClick={() =>
                  window.open(
                    "http://nfrta.taizhou.gov.cn/"
                  )
                }
              >
                <p className="block-word">融资E网通</p>
                {/* <img src={require("../assets/images/住房保障.png")} /> */}
              </div>
            </Paper>
          </Grid>
          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-4"
                onClick={() =>
                  window.open(
                    "http://www.jszwfw.gov.cn/jszwfw/tyqjd/tyqjd.do?tzdz=tzgcjs"
                  )
                }
              >
                <p className="block-word">工程建设</p>
                {/* <img src={require("../assets/images/住房保障.png")} /> */}
              </div>
            </Paper>
          </Grid>
        </Grid>
        <Grid
          style={{
            margin: "10px 10px 0 10px",
            width: "100%",
            paddingRight: "10px",
          }}
          container
          spacing={5}
        >
          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-5"
                onClick={() => window.open("http://218.94.38.242:56666/allChainLink/jsp/index.jsp")}
              >
                <p className="block-word">企业开办</p>
                {/* <p className="block-word-class">教育领域</p> */}
                {/* <img className="block-word-class" src={require("../assets/images/教育领域.png")} /> */}
              </div>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-6"
                onClick={() =>
                  window.open(
                    "http://zwfw.taizhou.gov.cn/ggzy/"
                  )
                }
              >
                <p className="block-word">公共资源</p>
                {/* <img src={require("../assets/images/企业开办.png")} /> */}
              </div>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-7"
                onClick={() =>
                  window.open(
                    "http://218.90.225.176:8086/jjbpt/yjs/home-page.html"
                  )
                }
              >
                <p className="block-word">就近办专栏</p>
                {/* <p className="block-word-class">社会保障</p> */}
                {/* <img className="block-word-class" src={require("../assets/images/社会保障.png")} /> */}
              </div>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper className={classes.paper} style={{overflow: "hidden"}}>
              <div
                className="block-class block-img-8"
                onClick={() =>
                  window.open(
                    "http://www.jszwfw.gov.cn/jszwfw/tyqjd/tyqjd.do?tzdz=tzqjdzjcs"
                  )
                }
              >
                <p className="block-word">中介服务</p>
                {/* <p className="block-word-class">社会保障</p> */}
                {/* <img className="block-word-class" src={require("../assets/images/社会保障.png")} /> */}
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchOffer);
